// Core
import { Box, Image, Grid, Flex, Text } from '@chakra-ui/react';
import { IoLocationSharp } from 'react-icons/io5';
import { TbRainbow } from 'react-icons/tb';
import { MdWork } from 'react-icons/md';
import { FaGenderless, FaRuler } from 'react-icons/fa';
import { MdOutlineInterests } from 'react-icons/md';

// Components
import BirthInfo from './BirthInfo';
import { textLang } from 'services/Lang';

const MatchInfo = ({ item }) => {
  const textColor = '#2b2b2b';
  const styleImage = {
    borderRadius: '16px',
    width: '100%',
    maxH: '400px',
    objectFit: 'cover'
  };

  return (
    <Box p="16px 20px 30px 20px">

      <Box>
        {/*<Flex justifyContent='space-between' alignItems='center'>
          <Text variant='title-xl' w='100%' textShadow="1px 1px black">{item?.firstName} {item?.lastName}</Text>
          
        </Flex>
        <BirthInfo birthDate={item?.birthday} color={textColor} />*/}

        <Text variant="title-lg" 
          fontWeight="800"
          mt="24px"
          mb="16px"
          textTransform="uppercase"
          fontSize="32px">{textLang('details')}</Text>

        <Grid templateColumns={{ base: '1fr 1fr' }} gap="8px" templateRows='1fr' mb="24px">

          <Flex gap="4px" mt="4px" alignItems="center">
            <FaGenderless color={textColor} fontSize="21px" /> 
            <Text variant="text-md" textShadow="0.5px 0.5px black">{textLang(item?.gender)}</Text>
          </Flex>

          <Flex gap="4px" mt="4px" alignItems="center">
            <MdOutlineInterests color={textColor} fontSize="21px" /> 
            <Text variant="text-md" textShadow="0.5px 0.5px black">{textLang('Interest')}: {textLang(item?.genderOfInterest)}</Text>
          </Flex>

          <Flex gap="4px" mt="4px" alignItems="center">
            <IoLocationSharp color={textColor} fontSize="21px" />
            <Text variant="text-md" textShadow="0.5px 0.5px black">{item?.country}, {item?.city}</Text>
          </Flex>

          { item?.religion && (
            <Flex gap="4px" mt="4px" alignItems="center">
              <TbRainbow color={textColor} fontSize="21px" /> 
              <Text variant="text-md" textShadow="0.5px 0.5px black">{textLang(item?.religion)}</Text>
            </Flex>
          )}

          { item?.career && (
            <Flex gap="4px" mt="4px" alignItems="center">
              <MdWork fontSize="21px" color={textColor} /> 
              <Text variant="text-md" textShadow="0.5px 0.5px black">{item?.career}</Text>
            </Flex>
          )}

          { item?.size && (
            <Flex gap="4px" mt="4px" alignItems="center">
              <FaRuler color={textColor} fontSize="21px" /> 
              <Text variant="text-md" textShadow="0.5px 0.5px black">{item?.size / 100}m</Text>
            </Flex>
          )}
        </Grid>

        <Text 
          variant="text-md" 
          mt="16px"
        >
          {item?.description}
        </Text>
        
        <Flex gap='8px' mt='12px' flexWrap='wrap'>
          {item?.interests?.map((item, index) => (
            <Box className='tag-interests' key={index}>{textLang(item)}</Box>
          ))}
        </Flex>
      </Box>

      <Text variant="title-lg" 
        fontWeight="800"
        mt="32px"
        mb="24px"
        textTransform="uppercase"
        fontSize="32px">{textLang('photos')}</Text>

      <Image src={item?.image} style={styleImage} maxH="600px" />
    </Box>
  );
};

export default MatchInfo;
